import React from "react";
import { Reveal } from "./Reveal";
import { CTA as CTA_COPY } from "../data/copy";

/**
 * Section 8 — CTA. Porcelain radial, mint dots, big headline, sub, graphite button.
 */
export const Cta = ({ onShop }) => {
  return (
    <section id="cta" className="mk-cta" data-testid="cta-section">
      <Reveal className="mk-cta__inner">
        <span className="mk-divider-dots" aria-hidden="true">
          <i />
          <i />
        </span>
        <h2 className="mk-cta__headline">{CTA_COPY.headline}</h2>
        <p className="mk-cta__sub">{CTA_COPY.sub}</p>
        <button
          type="button"
          className="mk-cta__button"
          onClick={onShop}
          data-testid="cta-shop-button"
        >
          {CTA_COPY.button}
        </button>
      </Reveal>
    </section>
  );
};

export default Cta;
